import { PropTypes } from 'prop-types';
import React from 'react';

function Upload(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.626 15.125C12.626 15.4702 12.3462 15.75 12.001 15.75C11.6558 15.75 11.376 15.4702 11.376 15.125V6.63388L8.69292 9.31694C8.44884 9.56102 8.05311 9.56102 7.80903 9.31694C7.56496 9.07286 7.56496 8.67714 7.80903 8.43306L11.559 4.68306C11.5608 4.68134 11.5625 4.67963 11.5642 4.67793C11.6769 4.56785 11.831 4.5 12.001 4.5C12.1688 4.5 12.3211 4.56613 12.4334 4.67374C12.4366 4.67681 12.4398 4.67991 12.4429 4.68306L16.1929 8.43306C16.437 8.67714 16.437 9.07286 16.1929 9.31694C15.9488 9.56102 15.5531 9.56102 15.309 9.31694L12.626 6.63388V15.125Z"
        fillRule="evenodd"
      />
      <path
        d="M21.376 15.125V16.375C21.376 17.038 21.1126 17.6739 20.6437 18.1428C20.1749 18.6116 19.539 18.875 18.876 18.875H5.12598C4.46294 18.875 3.82705 18.6116 3.35821 18.1428C2.88937 17.6739 2.62598 17.038 2.62598 16.375V15.125"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Upload.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Upload;
